import { createAsyncThunk } from '@reduxjs/toolkit';
import {  _mediaServiceUrls } from '@custom/Utils/constants/apiUrls';
import { ApiResponse } from '@custom/Utils/constants/interfaces';

const verifyStudyLink = createAsyncThunk('verifyStudyLink', async (value:any,{rejectWithValue}) => {

  const token = sessionStorage.getItem('token') || localStorage.getItem('token');

  const payload = {
    access_token : value
  }

  try {
    let response = await fetch(_mediaServiceUrls.verifyStudyLink, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body : JSON.stringify(payload)
    })
    const data: ApiResponse<any> = await response.json();
    if(response.status >= 200){
      return data
    }
    else{
      rejectWithValue('Failed to fetch')
      return rejectWithValue(data);
    }
  } catch (error) {
    return error;
  }
});

export default verifyStudyLink;
